<template>
    <div class="x-label">
        <div v-for="(lab, index) in getLabels(label)" :key="index">{{lab}}</div>
    </div>
</template>
<script setup>
import { computed, watch, ref } from 'vue';
import DataOptions from '../../dataview/DataOptions'
import { getDynamicOptions, getOptions, mergeFilter } from '../utils.js';

const props = defineProps({
    config: { default: null },
    modelValue: { default: null },
    data: { default: null },
    field: { default: null },
})
const dataOptions = ref(null);

const formatPrecision = (value, precision)=> {
    if (value == null) {} else {
        if (precision) {
            const vs = (value + '').split(/\s*\/\s*/);
            const rs = [];
            for (const v of vs) {
                let value = parseFloat(v);
                if (isNaN(value)) return;
                const vs = value.toFixed(precision);
                rs.push(vs.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'));
            }
            value = rs.join(' / ')
            return value;
        }
    }
    return value;
}

const label = ref(props.config?.value);
const getContent = async (modelValue, config)=> {
    if (config?.value) {
        label.value = config.precision ? formatPrecision(config.value, config.precision) : config.value;
        return;
    }
    let keys = modelValue;
    if (keys == null) {
        label.value = null;
        return;
    }
    if (!config?.dataOptions) {
        label.value = config.precision ? formatPrecision(modelValue, config.precision) : modelValue;
        return;
    }
    let options = null;
    if (!(config?.dataOptions instanceof Array)) {
        if (!(keys instanceof Array)) keys = [keys];
        const datas = await config?.dataOptions.dataInfo.getByKeysLocal(keys, config?.dataOptions.keyField);
        options = getDynamicOptions(config?.dataOptions, config.filter, props.data, datas);
    } else {
        options = getOptions(config.dataOptions, mergeFilter(config.localFilter, config.pathFilter), props.data)
    }
    if (!dataOptions.value) dataOptions.value = config?.dataOptions? new DataOptions(options) : null;
    else dataOptions.value.setOptions(options);
    const value = dataOptions.value ? dataOptions.value.getOptionLabel(modelValue, config?.lastLevel) : modelValue;
    label.value = value != null ? value : config.value;
    if (props.data && props.config?.map) {
        if (modelValue) {
            if (modelValue instanceof Array) {
                const source = await config?.dataOptions.dataInfo.getByKeysLocal(modelValue, config?.dataOptions.keyField);
                if (source) {
                    for (const [mapField, field] of Object.entries(props.config.map)) {
                        const vs = [];
                        for (const s of source) {
                            vs.push(s[field]);
                        }
                        props.data[mapField] = vs;
                    }
                }
            } else {
                const source = await config?.dataOptions.dataInfo.getDataLocal(modelValue, config?.dataOptions.keyField);
                if (source) {
                    for (const [mapField, field] of Object.entries(props.config.map)) {
                        props.data[mapField] = source[field];
                    }
                }
            }
        } else {
            for (const [mapField, field] of Object.entries(props.config.map)) {
                props.data[mapField] = null;
            }
        }
    }
}

const getLabels = (label)=> {
    if (label != null) label += '';
    else label = '';
    return label.split('\n');
}

watch(()=>props.modelValue, (value)=> {
    getContent(value, props.config);
}, {immediate:true})

watch(()=>props.config?.dataOptions, (value)=> {
    if (props.modelValue == null) return;
    getContent(props.modelValue, props.config);
}, {immediate:true})

defineEmits({
    'update:modelValue': null,
})
</script>
<style scoped>
    .x-label{
        display: inline-block;
    }
</style>
